import { Button } from "reactstrap";
import { PropsWithChildren } from "react";

interface Props {
  onClick: () => void;
  "data-cy"?: string;
}

export function Fab({
  onClick,
  children,
  "data-cy": dataCy,
}: PropsWithChildren<Props>) {
  return (
    <div className="position-fixed bottom-0 end-0 m-5 z-2">
      <Button onClick={() => onClick()} data-cy={dataCy} color="primary">
        {children}
      </Button>
    </div>
  );
}
